import React from 'react';
interface PageHeaderProps {
  eyebrow: string;
  titleLead: string;
  titleAccent: string;
  intro?: string;
}
export function PageHeader({
  eyebrow,
  titleLead,
  titleAccent,
  intro
}: PageHeaderProps) {
  return <header className="bg-cacao-900 px-6 pb-16 pt-40 text-center md:px-12 md:pb-20 md:pt-44" data-id="element-203" data-mp="3rdkiiukxxs06">
      <div className="mx-auto max-w-3xl" data-id="element-204" data-mp="3mgkhiy2y7ffx">
        <div aria-hidden="true" className="mx-auto mb-8 h-px w-32 bg-or/60" data-id="element-205" data-mp="3mdg73iyw3ngt" />
        <span className="mb-4 block font-sans text-[11px] uppercase tracking-[0.26em] text-caramel-light" data-id="element-206" data-mp="2yqgfgv5ernr1">
          {eyebrow}
        </span>
        <h1 className="font-serif text-3xl leading-tight text-creme md:text-5xl" data-id="element-207" data-mp="38fhr694x7iz7">
          {titleLead}{' '}
          <span className="italic text-caramel-light" data-id="element-208" data-mp="33ohvf77jf6ya">{titleAccent}</span>
        </h1>
        {intro && <p className="mx-auto mt-7 max-w-2xl font-sans font-light leading-relaxed text-creme/75" data-id="element-209" data-mp="2fynjcrv1lmf3">
            {intro}
          </p>}
      </div>
    </header>;
}